import React from "react";
import "../../assets/css/footer.css";
import PolicyModal from "../contents/PolicyModal";

const FooterArea = () => {
  return (
    <section>
      <div className="footer-container--top">
        <div className="text-white">
          <div className="spacer-box--m" />
          <div className="flex-row--center">
            <div className="yu-gothic">運営会社</div>
            <div className="row-spacer--l" />
            <div className="company-text">RAYWARD.Inc</div>
          </div>
          <div className="center url-text">https://rayward.jp</div>
        </div>
      </div>
      <div className="footer-container--bottom">
        <div className="footer-innner--bottom">
          <div className="flex-row">
            <div className="footer-text yu-gothic">@2021 RAYWARD.Inc</div>
            <div className="footer-text yu-gothic flex-row--justright ">
              <PolicyModal />
            </div>
            <div className="row-spacer--l" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FooterArea;
